module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "text-reader"
  }, [_vm._v("\n  Somente arquivos .csv separados por \";\"\n  "), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": ".csv"
    },
    on: {
      "change": _vm.loadTextFromFile
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-480a1d01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TextReader.vue
// module id = 633
// module chunks = 1